const standarizeLanguage = (language) => (language === 'us' ? 'en' : language);

export const getLinksByLanguage = (language = 'en', linksObj) => {
  const standardLanguage = standarizeLanguage(language);

  return linksObj[standardLanguage] || [];
};
